import httpClient from '@/http-client'

export const getProfile = (Options = {}) => {
  return httpClient
    .get('/api/home/student-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changePassword = data => {
  return httpClient
    .post('/api/home/student-change-passwords', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/student-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTotalMyRequest = (Options = {}) => {
  return httpClient
    .get('/api/home/student-get-total-my-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getApproveTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/student/approve-types')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getPaymentHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/student/get-payment-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationHistory = (Option = {}) => {
  return httpClient
    .get('/api/home/student/get-notification-histories', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getNotificationTypes = (Option = {}) => {
  return httpClient
    .get('/api/home/student/notification-types', Option)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  getProfile,
  changePassword,
  getMyRequest,
  getTotalMyRequest,
  getApproveTypes,
  getPaymentHistory,
  getNotificationHistory,
  getNotificationTypes
}
